module.exports = __webpack_public_path__ + "img/trailhead_logo01.a719c194.png";